import { useState } from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  AppBar,
  Toolbar,
  Icon,
  IconButton,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import PropTypes from 'prop-types';
import { DrawerHeader, localStyles } from './styles';
import styles from '../../assets/jss/material-dashboard-react/components/sidebarStyle';
import { Text, Link, Logo } from '..';
import COLORS from '../../styles/Colors';
import useAuth from '../../common/hooks/useAuth';

const useStyles = makeStyles(styles);

export default function Sidebar(props) {
  const { newComplaints } = useSelector((state) => state.complaintsReducer);
  const { newRequests } = useSelector((state) => state.requestsReducer);
  const Name = useSelector((state) => state.userReducer.decodeToken);
  const classes = useStyles();
  const { routes } = props;
  const container = window !== undefined ? () => window.document.body : undefined;
  const [mobileOpen, setMobileOpen] = useState(false);
  const { logout } = useAuth();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => (
    window.location.href.indexOf(routeName) > -1
  );

  const RouteName = ({ route }) => {
    const stateListItem = activeRoute(route.layout + route.path) && localStyles.activeListItem;

    return (
      <ListItem sx={[localStyles.listItem, stateListItem]}>
        {
          route.icon && (
            <Icon className={classNames(classes.itemIcon)}>
              <img src={route.icon} height={25} width={25} />
            </Icon>
          )
        }

        <ListItemText sx={localStyles.listItemText} disableTypography={true}>
          <div style={localStyles.notificationContainer}>
            {/* Route name */}
            {props.rtlActive ? route.rtlName : route.name}

            {/* Request's notifications */}
            {route.path === '/requests' && newRequests > 0 && (
              <span style={localStyles.notificationText}>
                {newRequests}
              </span>
            )}

            {/* Complaint's notifications */}
            {route.path === '/complaints' && newComplaints > 0 && (
              <span style={localStyles.notificationText}>
                {newComplaints}
              </span>
            )}
          </div>
        </ListItemText>
      </ListItem>
    );
  };

  const links = (
    <List className={classes.list}>
      <DrawerHeader>
        <Logo mode='light' />
        <IconButton onClick={handleDrawerToggle} sx={localStyles.iconButton}>
          <ChevronLeftIcon />
        </IconButton>
      </DrawerHeader>

      {
        routes
          .filter((prop) => prop.sidebar === true)
          .map((prop, key) => (
            prop.isExternalPath ? (
              <a
                href={prop.path}
                target='_blank'
                rel="noreferrer"
                key={key}
                style={localStyles.navLink}
              >
                <RouteName route={prop} />
              </a>
            ) : (
              <NavLink
                to={prop.layout + prop.path}
                activeClassName="active"
                key={key}
                style={localStyles.navLink}
              >
                <RouteName route={prop} />
              </NavLink>
            )
          ))
      }

      <ListItem style={localStyles.drawerFooter}>
        <ListItemText>
          <Text variant='hintText' sx={localStyles.userName}>{ Name && Name.user.name }</Text>
          <Text variant='label'>
            <Link onClick={logout} color={COLORS.PRIMARY_LIGHT}>Sair do painel</Link>
          </Text>
        </ListItemText>
      </ListItem>
    </List>
  );

  return (
    <>
      <AppBar position="fixed" sx={localStyles.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={localStyles.iconButton}
          >
            <MenuIcon color='primary' />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        container={container}
        variant="temporary"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={localStyles.mobileDrawer}
      >
        <div className={classes.sidebarWrapper}>{links}</div>
        <div />
      </Drawer>

      <Drawer
        variant="permanent"
        open
        sx={localStyles.webDrawer}
      >
        <div className={classes.sidebarWrapper}>{links}</div>
      </Drawer>
    </>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  routes: PropTypes.arrayOf(PropTypes.object),
};
